import React from "react";
import PlayersChart from "../components/players-chart";

const SelectPlayers = () => {
  return (
    <div>
      <h6 className="yellow-text text-mk w-100 bg-dark">TOYS MORTAL FIGHT</h6>
      <div className="players-chart">
        <PlayersChart />
      </div>
    </div>
  );
};

export default SelectPlayers;
